module.exports = __webpack_public_path__ + "static/media/close.7660da44.svg";